import { useCallback, useMemo } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useSiteControllerSettingTlLincoln } from "../../../../model/tl-lincoln/use-case/use-update-site-controller-setting-tl-lincoln";

import type { SiteControllerSettingTllFormModel } from "../../../../model/tl-lincoln/type";

type Props = {
	viewModel: SiteControllerSettingTllFormModel["ViewModel"];
	onResetViewModel: () => void;
};

export const useSettingsSiteControllerTlLincoln = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useSiteControllerSettingTlLincoln({ viewModel });

	// 初期設定かどうか
	const isFirstUpdate = useMemo(() => {
		return viewModel.tll.plans.value.length === 0 && viewModel.tll.rooms.value.length === 0;
	}, [viewModel.tll.plans.value, viewModel.tll.rooms.value]);

	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdate().finally(hideLoadingScreenCallback);

		if (!errors) {
			if (isFirstUpdate) {
				notifyUserEventInfo({
					title: "TLリンカーンとの連携を開始しました。15分ほどお待ちいただき、再リロードして再度設定を進めてください。",
				});
			} else {
				notifyUserEventInfo({
					title: "サイコン設定（TL-リンカーン）を更新しました",
				});
			}

			onResetViewModel();
		}
	}, [_onUpdate, hideLoadingScreenCallback, isFirstUpdate, onResetViewModel, showLoadingScreenCallback]);

	return {
		onUpdate,
	};
};
